import React from 'react';
import { useTranslation } from 'react-i18next';
import { Report } from '../../../types';
import './ReportInfo.css';

interface ReportInfoProps {
  report: Report | null | undefined;
  title?: string;
}

export const ReportInfo: React.FC<ReportInfoProps> = ({ report, title }) => {
  const { t } = useTranslation();

  if (!report) {
    return null;
  }

  const sl = report.serviceLocation;

  return (
    <section className="sidebar-section report-info">
      <h3>{title || t('sidebar.reportInfo')}</h3>
      <div className="sidebar-grid">
        <div className="sidebar-field">
          <label>{t('sidebar.reportNumber')}</label>
          <input type="text" value={report.number || ''} readOnly className="input-readonly" />
        </div>
        <div className="sidebar-field">
          <label>{t('sidebar.customer')}</label>
          <input type="text" value={report.customerName || ''} readOnly className="input-readonly" />
        </div>
        {sl?.description && (
          <div className="sidebar-field">
            <label>{t('sidebar.serviceLocationDescription')}</label>
            <input type="text" value={sl.description} readOnly className="input-readonly" />
          </div>
        )}
        <div className="sidebar-field">
          <label>{t('sidebar.technician')}</label>
          <input type="text" value={report.technicianName || ''} readOnly className="input-readonly" />
        </div>
      </div>
    </section>
  );
};

export default ReportInfo;
